import React, { Component, Fragment } from 'react';
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AutocompleteItems from './AutocompleteItems';
import includes from 'lodash/includes';
import toLower from 'lodash/toLower';
import AddressValidation from '../utils/AddressValidation';
import isWindow from 'components/common/helpers/isWindow';
import concat from 'lodash/concat';
import FlipMove from 'react-flip-move';
import CustomerAddressValidation from 'components/utils/CustomerAddressValidation';
import {
  HOME_TYPE,
  WORK_TYPE,
  OTHER_TYPE
} from 'components/common/constants/addressTypesConstants';
import merge from 'lodash/merge';
import axios from 'components/AppRequest';
import PriceList from 'components/common/helpers/PriceList';
import { connect } from 'react-redux';
import {
  fetchCustomerAddresses,
  createWarningNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import classNames from 'classnames';
import originAxios from 'axios';
import { GOOGLE_MAPS_GEOCODING_API } from 'components/windowEnvs';

const GOOGLE_SEARCH_DELAY = 1500;

class AddressComponent extends React.Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      isLogged: false,
      options: [],
      showAutocomplete: false,
      lastSearchedPhrase: null,
    };

    if (isWindow) {
      this.service = new google.maps.places.AutocompleteService();
    }
    this.wrapRef = React.createRef();
    this.inputMapRef = React.createRef();
    this.delayInput = null;
  }

  trans = (key, pref = 'content.bookingStep3') => {
    return TransHelper.translate(this.props.locale, pref + '.' + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.addressComponent');
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  componentDidUpdate(prevProps, prevState) {
    var phraseChanged = this.props.addressData.phrase !== prevProps.addressData.phrase;
    if (phraseChanged) {
      window.clearTimeout(this.delayInput);
      this.delayInput = window.setTimeout(this.showSuggestions, GOOGLE_SEARCH_DELAY);
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  handleClickOutside = (e) => {
    const autocomplete = ReactDOM.findDOMNode(this.refs.autocompleteRef);
    if (this.state.showAutocomplete) {
      const clickOutsideInputMap = this.inputMapRef.current && !this.inputMapRef.current.contains(e.target);
      const clickOutsideAutocompleteList = autocomplete && !autocomplete.contains(e.target);
      if (clickOutsideInputMap && clickOutsideAutocompleteList) {
        this.setState({ showAutocomplete: false })
      }
    }
  }

  showOnlyBusStops() {
    const { phrase, selectedObject } = this.props.addressData;
    if (selectedObject === null && phrase === '') {
      return true;
    }

    if (selectedObject && selectedObject.g) {
      return false;
    }

    for (var busKey in this.props.busStops) {
      var bs = this.props.busStops[busKey];
      if (phrase != '') {
        if (toLower(bs.name) === toLower(phrase)) {
          return true;
        }
      }
    }
    return false;
  }

  onFocusInput = () => {
    this.setState({ showAutocomplete: true });
    this.showSuggestions();
  }

  choosePlaceFromAutocomplete = (selectedOption) => {
    if (this.props.startLoadingDataOnMap) {
      this.props.startLoadingDataOnMap();
    }

    if (this.props.onItemChoose) {
      this.props.onItemChoose(selectedOption);
    }
    if (selectedOption.g) {
      //validate place is async request - stopLoadingDataOnMap will fire
      //when request end
      //geocode by place_id (not the label) - the label is localized text and
      //free-text geocoding does fuzzy/partial matches (e.g. "Norwegia" vs
      //"Norway" resolves to a transit_station without a street_number)
      this.validatePlace(selectedOption.value);
    } else {
      if (this.props.stopLoadingDataOnMap) {
        this.props.stopLoadingDataOnMap();
      }
    }
    this.setState({ showAutocomplete: false });
  }

  validatePlace = (placeId) => {
    var error = null;
    originAxios.get('https://maps.googleapis.com/maps/api/geocode/json', {
      params: {
        place_id: placeId,
        key: GOOGLE_MAPS_GEOCODING_API
      }
    })
      .then(response => {
        var geocodedData = response.data.results[0];
        if (geocodedData) {
          var validationResult = new AddressValidation(geocodedData);
          if (!validationResult.isPostCodeValid()) {
            error = this.trans('errors.postCode');
          }
          if (!validationResult.isStreetValid()) {
            error = this.trans('errors.street');
          }
          if (!validationResult.areCoordsValid()) {
            error = this.trans('errors.coords');
          }

        } else {
          error = this.trans('errors.addressNotFound');
        }

        if (error === null) {
          var priceHelper = new PriceList(this.props.priceList);
          var isAddressSupported = priceHelper.isAddressSupported(null, validationResult.postcode);
          if (!isAddressSupported) {
            error = this.trans('errors.addressNotSupported');
          }
        } //error

        this.props.setAddressPostcodeErrorLatLng(
          error,
          validationResult.postcode,
          validationResult.street,
          validationResult.getLatAndLng()
        );
        if (this.props.stopLoadingDataOnMap) {
          this.props.stopLoadingDataOnMap();
        }
      })
      .catch(err => {
        console.error(err)
      });
  }

  showSuggestions = () => {
    const { phrase } = this.props.addressData;
    var listAutocomplete = this.wrapRef.current;
    var addClassHeightAuto = 'map__select-wrap--height-auto';
    if (phrase == '' || this.showOnlyBusStops()) {
      this.displaySuggestions([], google.maps.places.PlacesServiceStatus.OK);
      listAutocomplete.classList.remove(addClassHeightAuto);
    } else {
      if (this.canSearchInGoogle()) {
        this.service.getPlacePredictions(
          {
            input: phrase,
            types: ['address'],
            componentRestrictions: { country: 'no' },
            location: new google.maps.LatLng({ lat: 59.754145, lng: 10.497871 }),
            radius: 54 * 1000
          },
          this.displaySuggestions
        );
      } else {
        this.displaySuggestions([], google.maps.places.PlacesServiceStatus.OK);
      }
      listAutocomplete.classList.add(addClassHeightAuto);
    }
  }

  displaySuggestions = (predictions, status) => {
    const { phrase } = this.props.addressData;
    var results = [];
    if (status != google.maps.places.PlacesServiceStatus.OK) {
      //if google fail with fetching address - show only busstops
      results = this.getBusStopsOptions(phrase, false);
    } else {
      if (this.showOnlyBusStops()) {
        results = this.getBusStopsOptions(phrase, true);
      } else {
        var prepareResults = [];
        for (var i = 0; i < predictions.length; i++) {
          var prediction = predictions[i];
          prepareResults.push({ g: true, label: prediction.description, value: prediction.place_id });
        }
        var busesAndUserAddresses = this.getBusStopsOptions(phrase, false);
        var results = concat(prepareResults, busesAndUserAddresses);
      }
    }
    this.setState({ options: results, lastSearchedPhrase: phrase });
  }

  createHashFromCustomerAddress(addressObject) {
    if (addressObject.is_bus_stop) {
      var isGoogleStreet = null;
      var label = addressObject.bus_stop_name;
      var value = addressObject.name;
    } else {
      var label = addressObject.name;
      var value = addressObject.google_place_id;
      var isGoogleStreet = true;
    }
    return {
      label: label,
      value: value,
      fav: true,
      g: isGoogleStreet,
      type: addressObject.type
    }
  }

  getBusStopsOptions = (phrase, displayOnlyBuStops = false) => {
    var opts = [];
    //customer's favourite
    if (this.props.customerAddresses && !this.props.disableCustomerAddresses) {
      const { customerAddresses } = this.props;
      for (var i = 0; i < customerAddresses.length; i++) {
        var ca = customerAddresses[i];
        if(!this.props.busStops[ca.name] && ca.is_bus_stop){
          continue;
        }

        if (displayOnlyBuStops) {
          opts.push(this.createHashFromCustomerAddress(ca));
        } else {
          if (phrase != '') {
            if (includes(toLower(ca.name), toLower(phrase))) {
              opts.push(this.createHashFromCustomerAddress(ca));
            }
          } else {
            opts.push(this.createHashFromCustomerAddress(ca));
          }
        }
      }
    }

    //bus stops
    for (var key in this.props.busStops) {
      var bs = this.props.busStops[key];
      if (displayOnlyBuStops) {
        opts.push({ label: bs.name, value: key });
      } else {
        if (phrase != '') {
          if (includes(toLower(bs.name), toLower(phrase))) {
            opts.push({ label: bs.name, value: key });
          }
        } else {
          opts.push({ label: bs.name, value: key });
        }
      }
    }
    return opts;
  }

  handleClickButtonAddFavi = (e) => {
    e.preventDefault();
    this.props.handleShowFavouriteList();
  }

  onKeyDown = (e) => {
    if (e.keyCode == 13) { //enter
      e.preventDefault();
    }
  }

  canShowButtonAddToFav = () => {
    return this.props.isLogged &&
      this.props.isBooking;
  }

  disableAddToFavButton = () => {
    return this.props.addressData.selectedObject === null ||
      this.props.addressData.error !== null ||
      !this.props.isValid ||
      this.props.loadingDataOnMap;
  }

  //save favourite place, hide spots list, refresh customer's places
  savePlace = (event, type) => {
    event.preventDefault();
    var params = merge({}, this.props.addressData);
    params.type = type;
    var addressHelper = new CustomerAddressValidation(params, this.props.busStops, this.props.locale);
    this.props.handleShowFavouriteList(false);
    if (addressHelper.isValidForm()) {
      var isDuplicated = addressHelper.isDuplicated(this.props.customerAddresses);
      if (isDuplicated) {
        this.props.createWarningNotification({
          title: this.transNotify('warning.title'),
          message: this.transNotify('warning.addressInDatabase')
        });
        return;
      }
      axios.post('/pwa/customer/create-address', addressHelper.getRequestParams())
        .then(response => {
          this.props.fetchCustomerAddresses();
        })
        .catch(err => {
          console.log('err', err)
        });
    } else {
      this.props.createWarningNotification({
        title: this.transNotify('warning.title'),
        message: this.transNotify('warning.addressInvalid')
      });
    }
  }

  canSearchInGoogle = () => {
    const { phrase } = this.props.addressData;
    if(this.state.lastSearchedPhrase === phrase){
      return false;
    }

    if(this.showOnlyBusStops()){
      return false;
    } else {
      return phrase.length >= 4;
    }
  }

  render() {
    const { phrase, selectedObject } = this.props.addressData;
    if(this.props.loadingDataOnMap){
      var isNotValid = false;
    } else {
      var isNotValid = !this.props.isValid && selectedObject !== null;
    }

    return (
      <Fragment>
        <div ref={this.wrapRef} className="map__select-wrap">
          <div className={
            classNames(
              'map__select',
              { 'map__select--error': isNotValid }
            )
          }>
            <div className="map__input">
              <input
                disabled={true}
                type="text"
                placeholder={this.trans('address.inputPlaceholder')}
                value={phrase}
                ref={this.inputMapRef}
              />
            </div>

            {this.canShowButtonAddToFav() &&
              <button
                style={{ left: 'initial', position: 'initial' }}
                className="button"
                title={this.trans('favButton')}
                onClick={this.handleClickButtonAddFavi}
                disabled={this.disableAddToFavButton()}
              >
                <span className="visuallyhidden">fovourite</span>
                <FontAwesomeIcon
                  icon={['fas', 'star']}
                  size="sm"
                />
              </button>
            }
          </div>

          <AutocompleteItems
            options={this.state.options}
            show={this.state.showAutocomplete}
            handleChange={this.choosePlaceFromAutocomplete}
            ref="autocompleteRef"
            locale={this.props.locale}
          />
        </div >

        <FlipMove
          duration={150}
          easing="ease-out"
          enterAnimation="fade"
          leaveAnimation="fade"
          typeName={null}>
          {this.props.showFavouriteList &&
            <div
              className="add-address__spots"
              style={{ position: 'absolute', right: '0' }}
            >
              <ul className="list-spots">
                <li className="list-spots__item list-spots__item--label">
                  {this.trans('favSpotButton')}
                </li>
                <li className="list-spots__item">
                  <button onClick={(e) => this.savePlace(e, HOME_TYPE)}>
                    <FontAwesomeIcon
                      icon={['fas', 'home']}
                      size="lg"
                    />
                    {this.trans('spots.home')}
                  </button>
                </li>
                <li className="list-spots__item">
                  <button onClick={(e) => this.savePlace(e, WORK_TYPE)}>
                    <FontAwesomeIcon
                      icon={['fas', 'briefcase']}
                      size="lg"
                    />
                    {this.trans('spots.work')}
                  </button>
                </li>
                <li className="list-spots__item">
                  <button onClick={(e) => this.savePlace(e, OTHER_TYPE)}>
                    <FontAwesomeIcon
                      icon={['fas', 'star']}
                      size="lg"
                    />
                    {this.trans('spots.other')}
                  </button>
                </li>
              </ul>
            </div>
          }
        </FlipMove>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    priceList: state.service.priceList,
    locale: state.app.locale,
  };
};

export default connect(
  mapStateToProps,
  { fetchCustomerAddresses, createWarningNotification })
  (AddressComponent);
